// Browser-compatible Pinecone implementation using REST API

const PINECONE_API_KEY = process.env.REACT_APP_PINECONE_API_KEY;
const PINECONE_HOST = process.env.REACT_APP_PINECONE_HOST;
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_APIKEY;

// Function to get embedding from Gemini using REST API
const getEmbedding = async (text) => {
  try {
    const response = await fetch(
      `https://generativelanguage.googleapis.com/v1beta/models/text-embedding-004:embedContent?key=${GEMINI_API_KEY}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          content: {
            parts: [{ text: text }],
          },
          taskType: "RETRIEVAL_QUERY",
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    let embedding = data.embedding?.values || [];

    // Pad to 1536 dimensions to match your Pinecone index
    if (embedding.length < 1536) {
      const padding = new Array(1536 - embedding.length).fill(0);
      embedding = [...embedding, ...padding];
    } else if (embedding.length > 1536) {
      embedding = embedding.slice(0, 1536);
    }

    return embedding;
  } catch (error) {
    console.error("Error getting embedding:", error);
    // Fallback: create a dummy embedding of correct size
    return new Array(1536).fill(0);
  }
};

// Function to search documents in Pinecone using REST API
export const searchDocuments = async (query, topK = 3) => {
  try {
    console.log("Searching for:", query);

    // Get embedding for the query
    const queryEmbedding = await getEmbedding(query);

    // Search in Pinecone using REST API
    const response = await fetch(`${PINECONE_HOST}/query`, {
      method: "POST",
      headers: {
        "Api-Key": PINECONE_API_KEY,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        vector: queryEmbedding,
        topK: topK,
        includeMetadata: true,
        includeValues: false,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const searchResults = await response.json();
    console.log("Search results:", searchResults);

    // Extract relevant documents
    const relevantDocs =
      searchResults.matches
        ?.filter((match) => match.score > 0.7) // Only include high-confidence matches
        .map((match) => ({
          content: match.metadata?.full_text || match.metadata?.text || "",
          score: match.score,
          source: match.metadata?.source || "unknown",
        })) || [];

    console.log("Relevant docs found:", relevantDocs.length);
    return relevantDocs;
  } catch (error) {
    console.error("Error searching documents:", error);
    return [];
  }
};
